import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { ArrowDownOutlined, ArrowUpOutlined, CloseOutlined, ShoppingOutlined } from '@ant-design/icons'
import i from '../../translations/i'
import { cleanText } from '../card_list/CardList'
import { productImage, ProductPickerMode, ProductTable } from './ProductTable'
import { ProductTableController } from './product_table.controller'

// Выбор товаров в модалках — та же таблица, что в каталоге, в режиме выбора.
// Список — как у прежнего выбора: /products/list с характеристиками (values_categories нужны связанным товарам),
// по умолчанию только показанные в каталоге; скрытые можно включить переключателем статуса
export const ProductPicker = observer(({ selectedIds, onToggle }: ProductPickerMode) => {
    const [table] = useState(() => new ProductTableController({
        endpoint: '/products/list',
        status: 'active',
        query: ['values_categories=1'],
    }))

    return <ProductTable table={table} picker={{ selectedIds, onToggle }} />
})

export interface PickedProduct {
    id: number
    // Карточка товара, если известна; иначе показываем только id
    product: any | null
}

// Что уже выбрано: счётчик и сброс, под ними — список выбранных (порядок можно менять, если передан onMove)
export const PickedProducts = observer(({ title, items, onReset, onRemove, onMove, empty }: {
    title: React.ReactNode
    // Без списка — только заголовок со счётчиком: выбранное экран показывает у себя
    items?: PickedProduct[]
    onReset?: () => void
    onRemove: (id: number) => void
    onMove?: (id: number, direction: 'up' | 'down') => void
    empty?: React.ReactNode
}) => (
    <div className="pt-picked">
        <div className="pt-picked__head">
            <span className="pt-picked__title">{title}</span>
            {onReset &&
                <Button size="small" type="link" danger icon={<CloseOutlined />} onClick={onReset}>{i.t('def:reset')}</Button>
            }
        </div>

        {items && (items.length === 0
            ? empty && <div className="pt-picked__empty">{empty}</div>
            : <ol className={`pt-picked__list${onMove ? ' pt-picked__list--ordered' : ''}`}>
                {items.map(({ id, product }, index) => {
                    const name = cleanText(product?.name)
                    const image = productImage(product?.image)

                    return (
                        <li key={id} className="pt-picked__item">
                            {onMove && <span className="pt-picked__index">{index + 1}</span>}
                            <span className={`pt-thumb pt-thumb--sm${image ? '' : ' pt-thumb--empty'}`}>
                                {image ? <img src={image} alt="" loading="lazy" /> : <ShoppingOutlined />}
                            </span>
                            <span className="pt-picked__body">
                                <span className="pt-picked__name" title={name}>{name || `#${id}`}</span>
                                {name && <span className="pt-picked__meta">#{id}</span>}
                            </span>
                            <span className="pt-picked__actions">
                                {onMove && <>
                                    <Tooltip title={i.t('productCards:moveUp')}>
                                        <Button type="text" size="small" icon={<ArrowUpOutlined />} disabled={index === 0} onClick={() => onMove(id, 'up')} />
                                    </Tooltip>
                                    <Tooltip title={i.t('productCards:moveDown')}>
                                        <Button type="text" size="small" icon={<ArrowDownOutlined />} disabled={index === items.length - 1} onClick={() => onMove(id, 'down')} />
                                    </Tooltip>
                                </>}
                                <Tooltip title={i.t('productCards:unpick')}>
                                    <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => onRemove(id)} />
                                </Tooltip>
                            </span>
                        </li>
                    )
                })}
            </ol>
        )}
    </div>
))
